module.exports = __webpack_public_path__ + "img/prompt.a5cde03c.png";